module.exports = __webpack_public_path__ + "mv.svg?a99b3a3eded0872f22f75e20216c2286";